import React from "react";
import addPrecision from "../../common/addPrecision";
import numberFormat from "../../common/numberFormat";
import LabelText from "../../common/LabelText";
import LetterFooter from "../../components/LetterFooter";
import removeCommas from "../../common/removeCommas";
import moment from "moment-timezone";
import LetterHeader from "../../components/LetterHeader";
import Table from "../../common/Table";
import { getInvoiceBusinessMonth } from "../../common/getInvoiceBusinessMonth";

const header = [
  { title: "Detail", name: "invoice_text" },
  { title: "Month", name: "month" },
  { title: "Amount", name: "price" },
];

const ContractInvoicePdfTemplate = ({ invoice = {}, contract = {} }) => {
  return (
    <div
      className="po-request"
      style={{
        width: "8.5in", // Letter width
        minHeight: "11in", // Letter height
        backgroundColor: "white",
        position: "relative",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div style={{ padding: "1cm", paddingTop: 0, flex: 1 }}>
        <div>
          <LetterHeader />
        </div>
        <div
          style={{
            width: "100%",
            backgroundColor: "black",
            margin: "10px 0px",
            color: "white",
            fontWeight: "900",
            padding: 10,
            textAlign: "center",
            letterSpacing: 4,
          }}
        >
          INVOICE
        </div>

        <div>
          <br />
          <div>
            <div className="d-flex" style={{ justifyContent: "space-between" }}>
              <LabelText
                columnMode
                label="INVOICE NO:"
                value={invoice.invoiceID}
              />

              <LabelText
                columnMode
                label="TAX REG NO"
                value={"81600 6993 RT 0001"}
              />
            </div>
          </div>
          <br />
          <br />
          <p>
            Issued on : {moment.utc(invoice.createdAt).format("MMMM DD, YYYY")}
          </p>
          <div>
            <div className="d-flex">
              <p>Invoice To :</p>
              <p
                style={{
                  maxWidth: 400,
                  paddingLeft: 5,
                  whiteSpace: "pre-line",
                }}
              >
                {contract.organization?.billingAddress &&
                  `${contract.organization?.billingAddress} \n`}
              </p>
            </div>
          </div>

          <div className="d-flex">
            <p>Job Date :</p>
            <p
              style={{
                maxWidth: 400,
                paddingLeft: 5,
              }}
            >
              {moment.utc(invoice.startDate).format("DD/MM/YYYY")} -
              {" " + moment.utc(invoice.endDate).format("DD/MM/YYYY")}
            </p>
          </div>

          <div className="d-flex">
            <span style={{ paddingRight: 10 }}>Job Location :</span>
            <p className="text-capitalize" style={{ whiteSpace: "pre-line" }}>
              {!Array.isArray(contract.location) && contract.location}
              {Array.isArray(contract.location) &&
                contract?.location?.map((i) => `${i?.title || i}\n`)}
            </p>
          </div>
          <div>
            <br />
            <br />

            <Table
              header={header}
              data={[
                {
                  invoice_text:
                    invoice.contract?.invoice_text || invoice?.invoice_text,
                  month: getInvoiceBusinessMonth(invoice),
                  price: `$ ${addPrecision(numberFormat(invoice.price))}`,
                },
              ]}
            />
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <div
                style={{
                  display: "flex",
                  width: 300,
                  gap: 10,
                  flexDirection: "column",
                }}
              >
                <LabelText
                  label="SUBTOTAL"
                  labelStyle={{ fontWeight: "500" }}
                  value={`$ ${addPrecision(numberFormat(invoice.price))}`}
                />
                <LabelText
                  label={`HST  (${invoice.tax}%)`}
                  value={`$ ${addPrecision(
                    (Number(removeCommas(invoice.price)) *
                      Number(invoice.tax)) /
                      100
                  )}`}
                />
                <LabelText
                  label="TOTAL"
                  labelStyle={{ fontWeight: "500" }}
                  value={`$ ${addPrecision(numberFormat(invoice.total))}`}
                  valueStyle={{ fontWeight: "600" }}
                />
              </div>
            </div>
            <br />
            <br />
          </div>
        </div>
      </div>

      {/* Footer fixed at bottom */}
      <div style={{ marginTop: "auto" }}>
        <LetterFooter />
      </div>
    </div>
  );
};

export default ContractInvoicePdfTemplate;
